<template>
  <div id="footer" class="container-fluid">
<!--    <div class="logo">-->
<!--      <img style="width: 100%" src="@/assets/img/dot_logo.png" alt="logo图">-->
<!--    </div>-->
<!--    <p class="title">广州数海科技有限公司</p>-->

<!--    <div class="address_tel_fax">-->
<!--      <div>地址：广州市天河区陶庄路五号空间创意园二楼2009室</div>-->
<!--      <span>电话：020-38895289</span>-->
<!--      <span style="margin-left: 10px">邮编：510507</span>-->
<!--      <span style="margin-left: 10px">渠道：marketing@dataoceantech.cn</span>-->
<!--    </div>-->


<!--    <p class="email_wx">-->
<!--      <span>邮箱：chenq@dataoceantech.cn</span>-->
<!--&lt;!&ndash;      <span>公司微信号：ilyk_gg</span>&ndash;&gt;-->
<!--    </p>-->
<!--    <p class="copy">Copyright &copy; 2020 - 2021 广州数海科技有限公司</p>-->


    <div class="foot-container" style="">
      Copyright &copy; 2021-2025 广州数海科技有限公司
      <a class="beian" target="_blank" style="color: #57B8FF;" href="https://beian.miit.gov.cn/#/Integrated/index">粤ICP备2021102888号</a>
<!--      <br>-->
<!--      <div style="display: flex;align-items: center;justify-content: center;">-->
<!--        <img style="width: 20px;margin-right: 5px" src="@/assets/img/dataocean/website.png" >-->
<!--       粤公网安备 xxxxxxxx 号-->
<!--      </div>-->
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  /*height: 100%;*/
  color: #d3d3d3;
  background: #003463;
  overflow: hidden;
  text-align: center;
  z-index: 999999;
}
.logo {
  width: 250px;
  /*height: 45px;*/
  margin: 25px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0 10px;
}
.foot-container{
  padding:7px 0;
  line-height: 25px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
  }
  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
  .beian{
    display: block;
  }
  .foot-container{
    padding:2px 0;
    line-height: unset;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue